var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-6"},_vm._l((_vm.ratingsList),function(rating){return _c('v-icon',{key:rating.value,class:[
			'mx-2 rating',
			rating.value === _vm.ratingSelect ? 'rating-selected' : '',
		],attrs:{"color":rating.color,"size":_vm.$vuetify.breakpoint.xs ? '32' : '50'},on:{"click":function($event){return _vm.listenClick(rating.value)}}},[_vm._v(" "+_vm._s(rating?.icon)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }